<!-- src/components/base/SohaDropdownItem.vue -->
<template>
  <div
    class="soha-dropdown-item"
    @click="$emit('click')"
  >
    <slot>
      <div class="navi-item">
        <a
          href="#"
          class="navi-link"
          @click.prevent="$emit('click')"
        >
          <span
            v-if="$slots.icon"
            class="navi-icon"
          >
            <slot name="icon" />
          </span>
          <span class="navi-text"><slot name="text" /></span>
          <span
            v-if="$slots.badge"
            class="navi-label"
          >
            <slot name="badge" />
          </span>
        </a>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'SohaDropdownItem',
  emits: ['click']
};
</script>